import { authService } from '@/services/authService.js';
import { authTokenService } from '@/services/authTokenService.js';
import ChangePassword from '@/views/ChangePassword.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import Assignment from '@/views/Assignment.vue';
import Validation from '@/views/Validation.vue';
import Management from '@/views/Management.vue';
import Reporting from '@/views/Reporting.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import NoAccess from '@/views/NoAccess.vue';
import Home from '@/views/Home.vue'

import Router from 'vue-router';
import { createWebHistory, createRouter } from "vue-router";

// Vue.use(Router);

// All routes require an auth token unless marked meta.guest = true

let routes = [
		{
			path: '/changepassword',
			name: 'changepassword',
			component: ChangePassword
		},
		{
			path: '/resetpassword',
			name: 'resetpassword',
			component: ResetPassword,
			meta: {
				guest: true
			}
		},
		{
			path: '/assignment',
			name: 'assignment',
			component: Assignment,
			meta: {
				role: 'assignmentAccess',
				guest: false
			}
		},
		{
			path: '/validation',
			name: 'validation',
			component: Validation,
			meta: {
				role: 'validationAccess',
				guest: false
			}
		},
		{
			path: '/management',
			name: 'management',
			component: Management,
			meta: {
				role: 'managementAccess',
				guest: false
			}
		},
		{
			path: '/reporting',
			name: 'reporting',
			component: Reporting,
			meta: {
				role: 'reportingAccess',
				guest: false
			}
		},
		{
			path: '/forgotpassword',
			name: 'forgotpassword',
			component: ForgotPassword,
			meta: {
				guest: true
			}
		},
		{
			path: '/noAccess',
			name: 'noAccess',
			component: NoAccess,
			meta: {
				guest: true
			}
		},
		{
			path: '/home',
			name: 'home',
			component: Home,
			meta: {
				guest: true
			}
		},

		{
			path: '/',
			alias: '/login',
			name: 'login',
			component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
			meta: {
				guest: true
			}
		},
	]

// Check for an auth token before proceeding to the next route.
//

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function getUserAccess () {
	let defaultStudy = authTokenService.getSelectedStudy();
	console.log('defaultStudy: ', defaultStudy);
	let roles = authTokenService.getRolesForStudy(defaultStudy);	
	console.log('getUserAccess roles: ', roles)
	var roleAcesses = []
	if (
		roles.includes("ROLE_SPECIALIST") ||
		roles.includes("ROLE_OPERATIONS") || 
		roles.includes("FIELD_OPERATIONS")
	  ) {
		roleAcesses.push("validationAccess");
	  }
	if (
		roles.includes("ROLE_SUPERVISOR") ||
		roles.includes("ROLE_OPERATIONS")
	  ) {
		roleAcesses.push("assignmentAccess");
	  }
	if (
		roles.includes("ROLE_OPERATIONS")
	  ) {
		roleAcesses.push("managementAccess");
		roleAcesses.push("reportingAccess");
	  }
	console.log('roleAcesses', roleAcesses)
	return roleAcesses
}

router.beforeEach((to, from, next) => {
	// Check if the route has a 'meta' property with a 'role' requirement
	if (to.meta && to.meta.role) {
	  // Get the user's role
	  const userAccess = getUserAccess();
  
	  // Check if the user has the required role
	  if (!userAccess.includes(to.meta.role)) {
		// User doesn't have the required role, redirect to a different page or deny access
		next('/noAccess'); // Redirect to a page for users without access
	  } else {
		// User has the required role, proceed to the route
		next();
	  }
	} else {
	  // If the route doesn't have a 'role' requirement, proceed
	  next();
	}
  });

export default router;
